module.exports = __webpack_public_path__ + "static/media/arrowdown.d942e771.svg";